import RegistrationNavBar from '@components/auth/navbar'
import TestimonialCard from '@components/auth/testimonial-card'
import DottedCardBackgroundWrapper from '@components/common/dotted-card-bg'
import I18nNextSeo from '@components/common/i18n/i18n-next-seo'
import BookTrialClassContainer from '@containers/book-trial-class/book-trial-class-container'
import {
  CODING_PROJECT_COURSES,
  MATH_TRIAL_CLASS,
} from '@lib/constants/booking'
import { ROLES } from '@lib/enums/dashboard'
import { registerSeo } from '@lib/seo'
import { t } from '@lingui/macro'
import { useRouter } from 'next/router'

const TestimonialCardWithDottedBackground = DottedCardBackgroundWrapper(
  TestimonialCard
)

export const RegisterPage = (): JSX.Element => {
  const router = useRouter()
  const next = router.query?.next?.toString()
  const course = router.query?.course?.toString()
  const isCodingProject = CODING_PROJECT_COURSES.includes(`${course}`)
  const isMathTrial = MATH_TRIAL_CLASS.includes(`${course}`)

  const getCtaMessage = () => {
    return isCodingProject
      ? t({
          id: 'register.cta.codingProject',
          message: 'Book a free mentorship session',
        })
      : t({
          id: 'register.cta',
          message: 'Proceed to book a free lesson',
        })
  }

  const getFormHeading = () => {
    return isCodingProject
      ? t({
          id: 'register.formHeading.codingProject',
          message: 'Start building your project',
        })
      : t({
          id: 'register.formHeading',
          message: "Let's get started",
        })
  }

  return (
    <>
      <I18nNextSeo {...registerSeo} />
      <div className="flex flex-col h-full min-h-screen slant-orange-split">
        <RegistrationNavBar role={ROLES.STUDENT} />
        <div className="flex items-center justify-between flex-1 h-full bg-white lg:bg-transparent">
          <div className="container h-full mx-auto">
            <div className="flex flex-wrap items-center h-full">
              <div className="items-center hidden w-full h-full pr-5 lg:flex lg:w-1/2">
                <TestimonialCardWithDottedBackground
                  isCodingProject={isCodingProject}
                />
              </div>
              <div className="w-full max-w-md px-4 lg:w-1/2">
                <BookTrialClassContainer
                  next={next}
                  cta={getCtaMessage()}
                  formHeading={getFormHeading()}
                  isMathTrial={isMathTrial}
                />
                <div className="flex justify-center w-full h-auto my-16 lg:hidden lg:w-1/2 md:px-5">
                  <TestimonialCard isCodingProject={isCodingProject} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RegisterPage
